require('backbone.marionette');
require('./spinner-button/spinner-button.scss');

var SIZES = {
    NONE: 'NONE',
    DEFAULT: 'DEFAULT',
    SMALL: 'SMALL',
    LARGE: 'LARGE'
};

var SIZE_CLASSNAMES = {
    NONE: '',
    DEFAULT: '',
    SMALL: 'btn-sm',
    LARGE: 'btn-lg'
};

var THEMES = {
    NONE: 'NONE',
    DEFAULT: 'DEFAULT',
    WARNING: 'WARNING',
    DANGER: 'DANGER',
    PRIMARY: 'PRIMARY',
    SUCCESS: 'SUCCESS'
};

var THEME_CLASSNAMES = {
    NONE: '',
    DEFAULT: 'btn btn-default',
    WARNING: 'btn btn-warning',
    DANGER: 'btn btn-danger',
    PRIMARY: 'btn btn-primary',
    SUCCESS: 'btn btn-success'
};

function LoadingSpinner($container, options) {
    var self = this;
    self.options = _.defaults(
        options || {},
        {
            fadeDuration: 300
        }
    );

    self.$spinner = $('<div>')
        .addClass('loadingSpinner');
    $container.append(self.$spinner);
    self.$spinner.hide().fadeIn(self.options.fadeDuration);
}

LoadingSpinner.prototype.destroy = function () {
    return this.$spinner.fadeOut(this.options.fadeDuration, (function (_this) {
        return function () {
            _this.$spinner.remove();
            return _this.$spinner = null;
        };
    })(this));
};

var SpinnerButton = Marionette.ItemView.extend({
    template: require('./spinner-button/spinner-button.html'),
    tagName: 'button',
    className: function () {
        var classNames = ['tl-spinner-button'];
        var sizeClassName = SIZE_CLASSNAMES[this.options.size];
        if (sizeClassName) {
            classNames.push(sizeClassName);
        }
        var themeClassName = THEME_CLASSNAMES[
            this.state &&
            this.state.get('theme') ||
            this.options.theme
        ];
        if (themeClassName) {
            classNames.push(themeClassName);
        }
        if (this.options.classNames) {
            classNames = classNames.concat(this.options.classNames);
        }

        if (this.state && this.state.get('label')) {
            classNames.push('tl-spinner-button-showing-label');
        }

        return classNames.join(' ');
    },
    ui: {
        label: '.tl-label'
    },
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {

                enabled: true,
                label: '',
                theme: THEMES.DEFAULT,
                size: SIZES.DEFAULT,
                classNames: '',
                multiClick: true,
                onClickedCallback: function () { },
                fadeDuration: 300,
                spinnerOn: false,
                classDuringLoading: 'spinning',
                glyphiconClassName: null
            }
        );

        this.state = new Backbone.Model({
            enabled: this.options.enabled,
            label: this.options.label,
            theme: this.options.theme,
            spinnerOn: this.options.spinnerOn
        });
        this.listenTo(this.state, 'change:theme', this.render);
    },
    events: {
        'click': '_onClicked',
    },
    _onClicked: function (e) {
        var isEnabled = this.state.get('enabled');
        if (!this.options.multiClick) {
            this.toggledEnabledState(false);
        }
        if (isEnabled) {
            if (this.options.onClickedCallback) {
                this.options.onClickedCallback(this, e);
            }
            this.trigger('clicked');
        }
    },
    toggleSpinner: function (on) {
        if (!this.isRendered) {
            return;
        }
        if (on) {
            this.$el.addClass(this.options.classDuringLoading);
            this.$childContent.animate({
                opacity: 0
            }, this.options.fadeDuration);

            if (!this.spinner) {
                this.spinner = new LoadingSpinner(this.$el, {
                    fadeDuration: this.options.fadeDuration
                });
            }
            this.toggledEnabledState(false);
            return this.$el.prop('disabled', 'true');
        } else {
            if (this.spinner) {
                this.$childContent.animate({
                    opacity: 1
                }, this.options.fadeDuration);
                this.spinner.destroy();
                this.spinner = null;
                this.$el.prop('disabled', '');
                this.toggledEnabledState(true);
                return this.$el.removeClass(this.options.classDuringLoading);
            }
        }
    },
    isEnabled: function () {
        return this.state.get('enabled');
    },
    setLabel: function (val) {
        this.state.set('label', val);
        this.ui.label.text(val);
    },
    setTheme: function (val) {
        this.state.set('theme', val);
    },
    toggledEnabledState: function (enabled) {
        if (enabled) {
            this.state.set('enabled', true);
            this.$el.removeClass('disabled');
        } else {
            this.state.set('enabled', false);
            this.$el.addClass('disabled');
        }
    },
    serializeData: function () {
        return {
            state: this.state.toJSON(),
            options: this.options
        };
    },
    onRender: function () {

        if (this.$el.children().length === 1) {
            this.$childContent = $(this.$el.children()[0]);
        } else {
            this.$childContent = $('<span></span>');
            if (this.$el.children().length > 1) {
                this.$childContent.append(this.$el.children());
            } else {
                this.$childContent.text(this.state.get('label'));
            }
            this.$el.append(this.$childContent);
        }

        // Calling this here because when backbone calls it
        // the options hash has not been set yet (i.e.
        // initialize has not been called at the time that
        // backbone calls className function)
        this.$el.attr('class', this.className());
        this.toggledEnabledState(this.state.get('enabled'));
        this.toggleSpinner(this.state.get('spinningOn'));
    }
});

module.exports = {
    SpinnerButton: SpinnerButton,
    THEMES: THEMES,
    SIZES: SIZES
};




/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/spinner-button.js
 ** module id = 19
 ** module chunks = 1 2 3 4 7 8 9 12 13 15 18 19 20 21 23 24 27 28 30 32 33 34 35 36 38 39 40 41 42 44 45 46 47 48 50 51 53 54 55 56 57 58 59 60 61 63 64 65 67 68 69 70 79 81 82 85 89 90 93 94 96 103 104 107 109 110 112 116 125 126 127 128
 **/